import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ToastProvider } from "@plataforma/design-system";
import "@plataforma/design-system/styles.css";
import type { PublicAppConfig } from "@plataforma/shared";
import { App } from "./app/App";
import { AuthProvider } from "./app/auth";
import { AppConfigProvider, applyBranding } from "./app/config";
import { api, errorMessage } from "./lib/api";

const root = createRoot(document.getElementById("root") as HTMLElement);
const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 15_000, retry: 1, refetchOnWindowFocus: true } } });

/**
 * A mesma build serve todas as aplicações: antes de desenhar qualquer tela, pergunta à API
 * qual é a aplicação deste endereço e aplica marca, tema e funcionalidades.
 */
try {
  const config = await api.get<PublicAppConfig>("/app-config");
  applyBranding(config);
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AppConfigProvider config={config}>
          <BrowserRouter>
            <ToastProvider>
              <AuthProvider>
                <App />
              </AuthProvider>
            </ToastProvider>
          </BrowserRouter>
        </AppConfigProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
} catch (error) {
  document.title = "Aplicação indisponível";
  root.render(
    <div className="ds-empty" style={{ paddingTop: 120 }}>
      <strong className="ds-empty__title">Não foi possível abrir a aplicação</strong>
      {errorMessage(error)}
    </div>,
  );
}
